module.exports = __webpack_public_path__ + "static/img/kesci.3bdadf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kesci.svg
// module id = p2fy
// module chunks = 0